import { useEffect, useState } from 'react'
import getPersonIds from './personIdsUtils'

export function usePersonIds(pedigree) {
  const [personIds, setPersonIds] = useState([])

  useEffect(() => {
    const setPersonIdsAsync = async () => {
      setPersonIds(await getPersonIds(pedigree))
    }
    setPersonIdsAsync()
  }, [pedigree])

  return personIds
}

export default usePersonIds
